var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[
    'o-link-arrow',
    { 'back': _vm.back },
    { 'o-link-reverse': _vm.darkMode },
    { 'disabled': _vm.disabled },
    { 'no-decoration': !_vm.decoration },
    { 'ob1-link-dark': _vm.black }
  ],attrs:{"to":_vm.to}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),(_vm.srLabel)?_c('span',{staticClass:"sr-only"},[_vm._v("\n    "+_vm._s(_vm.srLabel)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }